const EquipmentRoute = [
]

export default EquipmentRoute
